var PointsOverviewComponent = (function () {
    function PointsOverviewComponent() {
        this.actionPoints = 28;
    }
    PointsOverviewComponent.prototype.ngOnInit = function () {
    };
    return PointsOverviewComponent;
}());
export { PointsOverviewComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/points-overview/points-overview.component.ts.pre-build-optimizer.js